export const routes = {
  about: 'about',
  accountInfo: 'account-info',
  additionalPump: 'additional-pump',
  additionalPumpConfig: 'additional-pump-configuration',
  additionalPumpLevelDelay: 'additional-pump-level-delay',
  additionalPumpSettings: 'additional-pump-settings',
  adminHome: 'admin-home',
  addDevice: 'add-device',
  advancedSettings: 'advanced-settings',
  advProportionalMode: 'advanced-proportional-mode',
  alarmSetting: 'alarm-settings',
  automaticPresets: 'automatic-pre-sets',
  automaticUpdate: 'automatic-update',
  aux: 'aux',
  buzz: 'buzzer',
  chlorinator: 'chlorinator',
  chlorinatorSettings: 'chlorinator-settings',
  chlorinatorConfig: 'chlorinator-configuration',
  connectOrganization: 'connect-organization',
  delayAfterCalibration: 'delay-after-calibration',
  device: 'device',
  deviceConfiguration: 'device-configuration',
  deviceConfigurationChannel: 'device-configuration-channel',
  deviceSettingSelection: 'select-setting',
  deviceSettingSelectionSalt: 'select-setting',
  deviceSelection: 'device-selection',
  externalSignal: 'external-signals',
  editPlant: 'edit-plant',
  factoryData: 'factory-data',
  first_setup: 'first-setup',
  forgotPassword: '/forgot-password',
  home: '/',
  iceAlert: 'ice-alert',
  language: 'language',
  levelAlarm: 'level-alarm',
  levelSensors: 'level-sensor',
  login: '/login',
  lowSalinity: 'low-salinity',
  mA: 'mA',
  maintenance: 'maintenance',
  minMax: 'min-max-value',
  members: 'members',
  multiDevice: 'multi-device',
  multi_configuration: 'multi-configuration',
  multiPumpsConf: 'multi-pumps-configuration',
  multiPumpsStartup: 'multi-pumps-startup',
  newOrganizzation: 'new-organizzation',
  newPlant: '/new-plant',
  notifications: '/notifications',
  notificationsSettings: 'notifications-settings',
  ofa: 'over-feed-alarm',
  out: 'out',
  outputConfiguration: 'output-configuration',
  overUnderDosingAlarm: 'over-under-dosing-alarm',
  parameters: 'parameters-trend',
  parametersChart: 'parameters-chart',
  passwordAndSecurity: 'password-and-security',
  people: '/people',
  peopleAccount: 'people-account',
  phPriority: 'ph-priority',
  plants: '/plants',
  polarityReversalScheduling: 'polarity-reversal-scheduling',
  poolCover: 'pool-cover',
  postBoostAlarm: 'post-boost-alarm',
  pressureCalibration: 'pressure-calibration',
  probeCalibration: 'probe-calibration',
  process: 'process',
  profileMember: 'profile-member',
  proximitySensor: 'proximity-sensor',
  pumpCalibration: 'pump-calibration',
  pumpPriming: 'pump-priming',
  pumpSetup: 'pump-setup',
  resetAndReboot: 'reset-and-reboot',
  reboot: 'reboot',
  rotationPercentage: 'motor-rotation-percentage',
  salinityCalibration: 'salinity-calibration',
  salinityControl: 'salinity-control',
  settings: 'settings',
  selectNewOwner: 'select-new-owner',
  selectPlantMobileApp: 'select-plant-mobile-app',
  selectionSensors: 'select-sensors',
  serialPort: 'serial-port',
  setup: 'setup',
  signup: '/sign-up',
  softwareUpdate: 'software-update',
  standby: 'standby',
  startup: 'startup',
  temperature: 'compensation-temperature',
  winterModeAuto: 'winter-mode-auto',
};
